import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { HeadingText } from '@paypalcorp/pp-react'
import { headingTextCss } from './styles'
import { css } from '@emotion/core'
import cx from 'clsx'

const getHeaderStyle = (align) => css`
  &.papui_modal__header {
    text-align: ${align};
  }
`
export default function ModalHeader(props) {
  useEffect(() => {
    const headingText = document.getElementById('modal-header')
    if (headingText) {
      headingText.focus()
    }
  }, [])

  const { textHeader, align, size = 'sm', children, className, ...restProps } = props

  // data-top-heading is used to customize the heading title top margin, the margin is
  // increased when navigation bar is hidden, and vice versa to normalize the visible
  // empty space
  return (
    <div
      className={cx('papui_modal__header', className)}
      css={getHeaderStyle(align)}
      {...restProps}
    >
      {textHeader ? (
        <HeadingText as="h2" size={size} id="modal-header" tabIndex="-1" css={headingTextCss}>
          {children}
        </HeadingText>
      ) : (
        children
      )}
    </div>
  )
}

ModalHeader.propTypes = {
  textHeader: PropTypes.bool,
  align: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
}

ModalHeader.defaultProps = {
  textHeader: true,
}
